import { Box } from '@mui/material'
import { StartHome } from '../../assets/svgs/StartHome'
import { LoginPage } from './Login'
import { PAGE_MARGIN_TOP, PAGE_MARGIN_X } from '../masterComponents/layout'

interface RedirectLoginProps {
  returnUrl?: string
}

export function RedirectLogin ({ returnUrl }: RedirectLoginProps): JSX.Element {
  return <Box>
    <StartHome
      style={{
        position: 'relative',
        width: '100vw',
        height: 'fit-content',
        left: `-${PAGE_MARGIN_X / 2}vw`,
        top: `-${PAGE_MARGIN_TOP}vh`,
        marginLeft: `-${PAGE_MARGIN_X / 2}vw`,
        marginRight: `-${PAGE_MARGIN_X / 2}vw`
      }}
    />
    <LoginPage returnUrl={returnUrl} />
  </Box>
}
